import React from 'react'

// styles
import * as SC from './ChipStyles'

// types
import { ChipProps } from './types'

const Chip = (props: ChipProps) => {
	const {
		label,
		isMainButtonChip,
		isSelected,
		count,
		onClick,
		onCloseBtnClick,
		disabled,
		ariaLabel,
		closeAriaLabel,
		closeDecorative,
		expanded,
		hasPopup,
		controlsId
	} = props

	const showClose = !isMainButtonChip && isSelected
	const countNode = isSelected && count && count > 1 ? <SC.Count $disabled={disabled}>{`+${count}`}</SC.Count> : null

	return (
		<SC.ChipRoot $isSelected={isSelected} $isMainButtonChip={isMainButtonChip} $isDisabled={disabled}>
			{/* Sizer keeps pill width while action/close are absolutely layered */}
			<SC.ChipWidthSizer $hasClose={showClose} aria-hidden>
				<SC.Label>{label}</SC.Label>
				{countNode}
			</SC.ChipWidthSizer>
			<SC.ChipAction
				type='button'
				$hasClose={showClose}
				onClick={(e) => {
					e.stopPropagation()
					onClick()
				}}
				disabled={disabled}
				aria-label={ariaLabel}
				aria-expanded={hasPopup !== undefined ? expanded : undefined}
				aria-haspopup={hasPopup}
				aria-controls={controlsId}
			>
				<SC.Label>{label}</SC.Label>
				{countNode}
				{isMainButtonChip && <SC.SelectedBadge $isSelected={isSelected} $disabled={disabled} />}
			</SC.ChipAction>
			{showClose &&
				(closeDecorative ? (
					<SC.CloseVisual aria-hidden $disabled={disabled}>
						<SC.CloseIcon aria-hidden />
					</SC.CloseVisual>
				) : (
					<SC.CloseButton
						type='button'
						aria-label={closeAriaLabel}
						onClick={(e) => {
							e.stopPropagation()
							onCloseBtnClick?.()
						}}
						disabled={disabled}
						$disabled={disabled}
					>
						<SC.CloseIcon aria-hidden />
					</SC.CloseButton>
				))}
		</SC.ChipRoot>
	)
}

export default Chip
